/**
 * Most files one composer message may carry (#7626). One constant: the server
 * refusal and every localized copy derive their text from it. Kept free of
 * imports so client code can read it without pulling in server modules.
 */
export const MAX_SEND_ATTACHMENTS = 10;
